<template>
  <div v-drag id="uploader-fixed-wrap" style="width: 400px;" v-show="visible">
    <upload :showList="true" />
  </div>
</template>
<script>
import upload from '@/components/upload'
import { mapGetters } from 'vuex'
export default {
  components: {
    upload
  },

  directives: {
    drag: {
      bind(el) {
        el.style.position = 'fixed'
        el.style.right = '60px'
        el.style.bottom = '60px'
        el.style.zIndex = '9999'

        // 获取el下的子元素#
        let arrow = el.querySelector('.upload-header')
        arrow.style.cursor = 'move'

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = (function() {
          if (window.document.currentStyle) {
            return (dom, attr) => dom.currentStyle[attr]
          } else {
            return (dom, attr) => getComputedStyle(dom, false)[attr]
          }
        })()

        arrow.onmousedown = function(e) {
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX = e.clientX - arrow.offsetLeft
          const disY = e.clientY - arrow.offsetTop

          const screenWidth = document.body.clientWidth // body当前宽度
          const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

          const dragDomWidth = el.offsetWidth // 对话框宽度
          const dragDomheight = el.offsetHeight // 对话框高度

          const minDragDomLeft = el.offsetLeft
          const maxDragDomLeft = screenWidth - el.offsetLeft - dragDomWidth

          const minDragDomTop = el.offsetTop
          const maxDragDomTop = screenHeight - el.offsetTop - dragDomheight

          // 获取到的值带px 正则匹配替换
          let styL = sty(el, 'left')
          let styT = sty(el, 'top')

          // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
          if (styL.includes('%')) {
            styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
            styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
          } else {
            styL = +styL.replace(/\px/g, '')
            styT = +styT.replace(/\px/g, '')
          }

          document.onmousemove = function(e) {
            // 通过事件委托，计算移动的距离
            let left = e.clientX - disX
            let top = e.clientY - disY

            // 边界处理
            if (-left > minDragDomLeft) {
              left = -minDragDomLeft
            } else if (left > maxDragDomLeft) {
              left = maxDragDomLeft
            }

            if (-top > minDragDomTop) {
              top = -minDragDomTop
            } else if (top > maxDragDomTop) {
              top = maxDragDomTop
            }

            // 移动当前元素
            el.style.right = 'unset'
            el.style.bottom = 'unset'
            el.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
          }
          document.onmouseup = function() {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters('admin/upload', ['number'])
  },
  watch: {
    number(val) {
      this.visible = val > 0
    }
  }
}
</script>
